import { render } from "./AddNumberSection.vue?vue&type=template&id=d9413dcc&scoped=true"
import script from "./AddNumberSection.vue?vue&type=script&lang=js"
export * from "./AddNumberSection.vue?vue&type=script&lang=js"

import "./AddNumberSection.vue?vue&type=style&index=0&id=d9413dcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9413dcc"]])

export default __exports__